import { queryOptions } from '@tanstack/react-query';
import { GetEducationDetailQueryParamsType } from './getEducationDetailQuery.type';
import { getEducationDetailFunction } from './getEducationDetailQueryFunction';

export const getEducationDetailQueryOptions = (
  params: GetEducationDetailQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['education-detail', params.id],
    queryFn: () => getEducationDetailFunction(params),
    enabled: !!params.id,
  });
};
